export const HUBSPOT_TO_LEAD_DATA_MAP = {
    first_name: "firstname",
    last_name: "lastname",
    email: "email",
    job_title: "jobtitle",
    phone: "phone",
    company_name: "company",
    company_size: "company_size__c",
    product: "product_question_hs_forms"
};
